<template>

</template>

<script>
    import Router from '../../router.js'

    export default {
        name: "InstantMarketingHome",
        props: {},
        components: {
        },
        computed: {
        },
        data() {
            return {
                templatingValues: {},
            }
        },
        mounted() {
            let valid = true;

            console.log('this.$route.query.gotoPage=' + this.$route.query.gotoPage);
            console.log('this.$route.query.orderId=' + this.$route.query.orderId);
            console.log('this.$route.query.showProfile=' + this.$route.query.showProfile);
            console.log('this.$route.query.showTemplates=' + this.$route.query.showTemplates);

            var showTemplates = this.$route.query.showTemplates;

            if (showTemplates !== undefined && showTemplates !== null) {
                if (showTemplates === 'true') {
                    window.sessionStorage.setItem('_showTemplates', true);
                    this.navigate('templates');
                    return;
                }
            }

            this.templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));

            console.log('this.templatingValues.varCompany_Logo_1=' + this.templatingValues.varCompany_Logo_1);
            console.log('this.templatingValues.varCompany_Logo_2=' + this.templatingValues.varCompany_Logo_2);

            if (this.templatingValues.varCompany_Logo_1 === undefined) {
                valid = false;
            } else {
                if (this.templatingValues.varCompany_Logo_1 === '') {
                    valid = false;
                }
            }

            if (this.templatingValues.varCompany_Logo_2 === undefined) {
                valid = false;
            } else {
                if (this.templatingValues.varCompany_Logo_2 === '') {
                    valid = false;
                }
            }

            // if (this.templatingValues.varCompany_Logo_3 === undefined) {
            //     valid = false;
            // } else {
            //     if (this.templatingValues.varCompany_Logo_3 === '') {
            //         valid = false;
            //     }
            // }

            // if (this.templatingValues.varCompany_Logo_4 === undefined) {
            //     valid = false;
            // } else {
            //     if (this.templatingValues.varCompany_Logo_4 === '') {
            //         valid = false;
            //     }
            // }

            console.log('this.templatingValues.varCompany_Colour_1=' + this.templatingValues.varCompany_Colour_1);

            if (this.templatingValues.varCompany_Colour_1 === undefined) {
                valid = false;
            } else {
                if (this.templatingValues.varCompany_Colour_1 === '') {
                    valid = false;
                }
            }

            // if (this.templatingValues.varCompany_Colour_2 === undefined) {
            //     valid = false;
            // } else {
            //     if (this.templatingValues.varCompany_Colour_2 === '') {
            //         valid = false;
            //     }
            // }

            // if (this.templatingValues.varCompany_Colour_3 === undefined) {
            //     valid = false;
            // } else {
            //     if (this.templatingValues.varCompany_Colour_3 === '') {
            //         valid = false;
            //     }
            // }

            console.log('valid=' + valid);

            if (valid) {
                var gotoPage = this.$route.query.gotoPage,
                    orderId = this.$route.query.orderId,
                    showProfile = this.$route.query.showProfile;

                if (showProfile !== undefined && showProfile !== null) {
                    if (showProfile === 'true') {
                        window.sessionStorage.setItem('_showProfile', true);
                        this.navigate('profile');
                        return;
                    }
                }

                if (gotoPage === undefined) {
                    this.navigate('fulfilment');
                } else {
                    window.sessionStorage.setItem('_order_id', orderId);

                    if (gotoPage === 'Databook') {
                        this.navigate('select-data-databook');
                    } else if (gotoPage === 'Leadhub') {
                        this.navigate('select-data-leadhub');
                    } else if (gotoPage === 'PreviewData') {
                        this.navigate('data-preview');
                    } else if (gotoPage === 'SelectTemplate') {
                        this.navigate('select-design-type');
                    } else if (gotoPage === 'PersonaliseDesign') {
                        this.navigate('personalise-design');
                    } else if (gotoPage === 'PrintOptions') {
                        this.navigate('print-options');
                    } else if (gotoPage === 'Checkout') {
                        this.navigate('checkout');
                    }
                }
            } else {
                this.navigate('profile');
            }
        },
        methods: {
            navigate(path) {
                setTimeout(function () {
                    console.log('new page')
                    Router.push({
                        path: '/' + path,

                    });
                }, 2);
            }
        },
    };
</script>